// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-button {
  padding: 10px 20px;
  border: none;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100%;
  height: 56px;
  padding: 10px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: background-color 0.3s, box-shadow 0.3s;
}

.warnling-btn {
  height: 40px;
  border-radius: 8px;
}

.warnling-no-btn {
  border: 1px solid #EC6A5E;
}

.download-btn {
  height: 40px;
  border-radius: 8px;
  font-size: 14px;
}

.primary {
  background-color: #00aa74;
}

.secondary {
  border: 1px solid #ec6a5e;
  color: #EC6A5E;
}

.chatButton {
  border: 1px solid #D9D9D9;
  background-color: white;
  color: #00AA74;
}

.addWallet {
  border-radius: 8px !important;
}

.disabled {
  background-color: #d9d9d9;
  cursor: not-allowed;
}

.glow-primary {
  animation: glowAnimation 1s infinite alternate;
}

.glow-secondary {
  animation: glowAnimation 1s infinite alternate;
}

@keyframes glowAnimation {
  0% {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.4); /* Default glow color */
  }
  100% {
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.2); /* Default glow color */
  }
}
/* Update glow color for primary variant */
.custom-button.primary.glow-primary {
  animation: glowAnimationPrimary 1s infinite alternate;
}

@keyframes glowAnimationPrimary {
  0% {
    box-shadow: 0 0 20px rgba(0, 170, 116, 0.8); /* Primary glow color */
  }
  100% {
    box-shadow: 0 0 40px rgba(0, 170, 116, 0.6); /* Primary glow color */
  }
}
/* Update glow color for secondary variant */
.custom-button.secondary.glow-secondary {
  animation: glowAnimationSecondary 1s infinite alternate;
}

@keyframes glowAnimationSecondary {
  0% {
    box-shadow: 0 0 20px rgba(236, 106, 94, 0.8); /* Secondary glow color */
  }
  100% {
    box-shadow: 0 0 40px rgba(236, 106, 94, 0.6); /* Secondary glow color */
  }
}
.StartCharging-button {
  background-color: #EC6A5E;
}

.WalletLayout--btn {
  height: 49px;
  border-radius: 8px;
}

.WalletLayout-secondary {
  border: 1px solid #FFF;
  color: white;
  background: linear-gradient(108deg, #00AA74 -78.7%, #1E1E1E 59.58%);
}

.AddVehiclesView-btn {
  height: 56px;
  border-radius: 12px;
}

.WalletLayout-btn-No {
  background-color: white;
  color: #EC6A5E;
  border: 1px solid #EC6A5E;
}

.WalletLayout-btn-Yes {
  border: 2px solid #00aa74;
}

.transparent {
  background-color: transparent;
  color: #00aa74;
}

/* Update glow color for transparent variant */
.custom-button.transparent.glow-transparent {
  animation: glowAnimationSecondary 1s infinite alternate;
}

@keyframes glowAnimationTransparent {
  0% {
    box-shadow: 0 0 20px rgba(236, 106, 94, 0.8); /* Secondary glow color */
  }
  100% {
    box-shadow: 0 0 40px rgba(236, 106, 94, 0.6); /* Secondary glow color */
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Common/Button/Button.scss","webpack://./src/Styles/sass/_variables.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kDAAA;AAAJ;;AAEA;EACI,YAAA;EACA,kBAAA;AACJ;;AACA;EACI,yBAAA;AAEJ;;AAAA;EACI,YAAA;EACA,kBAAA;EACA,eAAA;AAGJ;;AAAI;EACI,yBAAA;AAGR;;AAAI;EACI,yBAAA;EAED,cAAA;AAEP;;AACI;EACI,yBAAA;EACA,uBAAA;EACD,cAAA;AAEP;;AAAI;EACI,6BAAA;AAGR;;AADI;EACI,yBAAA;EACA,mBAAA;AAIR;;AADI;EACI,8CAAA;AAIR;;AADI;EACI,8CAAA;AAIR;;AADI;EACI;IACI,uCAAA,EAAA,uBAAA;EAIV;EAFM;IACI,uCAAA,EAAA,uBAAA;EAIV;AACF;AADI,0CAAA;AACA;EACI,qDAAA;AAGR;;AACA;EACI;IACI,2CAAA,EAAA,uBAAA;EAEN;EAAE;IACI,2CAAA,EAAA,uBAAA;EAEN;AACF;AACA,4CAAA;AACA;EACI,uDAAA;AACJ;;AAEA;EACI;IACI,4CAAA,EAAA,yBAAA;EACN;EACE;IACI,4CAAA,EAAA,yBAAA;EACN;AACF;AAEA;EACI,yBAAA;AAAJ;;AAEA;EACI,YAAA;EACA,kBAAA;AACJ;;AACA;EACI,sBAAA;EACA,YAAA;EACA,mEC7GgB;AD+GpB;;AACA;EACI,YAAA;EACA,mBAAA;AAEJ;;AAAA;EACI,uBAAA;EACA,cAAA;EACA,yBAAA;AAGJ;;AADA;EACI,yBAAA;AAIJ;;AAFA;EACI,6BAAA;EACA,cCjIY;ADsIhB;;AAFA,8CAAA;AACA;EACI,uDAAA;AAKJ;;AAFA;EACI;IACI,4CAAA,EAAA,yBAAA;EAKN;EAHE;IACI,4CAAA,EAAA,yBAAA;EAKN;AACF","sourcesContent":["@import '../../../Styles/sass/variables';\n.custom-button {\n    padding: 10px 20px;\n    border: none;\n    color: white;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    width: 100%;    \n    height: 56px;\n    padding: 10px;\n    border-radius: 12px;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 19px;\n    letter-spacing: 0px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    transition: background-color 0.3s, box-shadow 0.3s;\n}\n.warnling-btn{\n    height: 40px;\n    border-radius: 8px;\n}\n.warnling-no-btn{\n    border: 1px solid #EC6A5E;\n}\n.download-btn{\n    height: 40px;\n    border-radius: 8px;\n    font-size: 14px;\n}\n\n    .primary {\n        background-color: #00aa74;\n    }\n\n    .secondary {\n        border: 1px solid #ec6a5e;\n        // background-color: white;\n       color: #EC6A5E;\n\n    }\n    .chatButton{\n        border: 1px solid #D9D9D9;\n        background-color: white;\n       color: #00AA74;\n    }\n    .addWallet{\n        border-radius: 8px !important;\n    }\n    .disabled {\n        background-color: #d9d9d9;\n        cursor: not-allowed;\n    }\n\n    .glow-primary {\n        animation: glowAnimation 1s infinite alternate;\n    }\n\n    .glow-secondary {\n        animation: glowAnimation 1s infinite alternate;\n    }\n\n    @keyframes glowAnimation {\n        0% {\n            box-shadow: 0 0 20px rgba(0, 0, 0, 0.4); /* Default glow color */\n        }\n        100% {\n            box-shadow: 0 0 40px rgba(0, 0, 0, 0.2); /* Default glow color */\n        }\n    }\n\n    /* Update glow color for primary variant */\n    .custom-button.primary.glow-primary {\n        animation: glowAnimationPrimary 1s infinite alternate;\n    }\n// }\n\n@keyframes glowAnimationPrimary {\n    0% {\n        box-shadow: 0 0 20px rgba(0, 170, 116, 0.8); /* Primary glow color */\n    }\n    100% {\n        box-shadow: 0 0 40px rgba(0, 170, 116, 0.6); /* Primary glow color */\n    }\n}\n\n/* Update glow color for secondary variant */\n.custom-button.secondary.glow-secondary {\n    animation: glowAnimationSecondary 1s infinite alternate;\n}\n\n@keyframes glowAnimationSecondary {\n    0% {\n        box-shadow: 0 0 20px rgba(236, 106, 94, 0.8); /* Secondary glow color */\n    }\n    100% {\n        box-shadow: 0 0 40px rgba(236, 106, 94, 0.6); /* Secondary glow color */\n    }\n}\n\n.StartCharging-button{\n    background-color: #EC6A5E;\n}\n.WalletLayout--btn{\n    height: 49px;\n    border-radius: 8px;\n}\n.WalletLayout-secondary{\n    border: 1px solid #FFF;\n    color: white;\n    background: $primary_gradient1;\n\n}\n.AddVehiclesView-btn{\n    height: 56px;\n    border-radius: 12px;\n}\n.WalletLayout-btn-No{\n    background-color: white;\n    color: #EC6A5E;\n    border: 1px solid #EC6A5E;\n}\n.WalletLayout-btn-Yes{\n    border: 2px solid $primary_green;\n}\n.transparent{\n    background-color: transparent;\n    color: $primary_green;\n}\n\n/* Update glow color for transparent variant */\n.custom-button.transparent.glow-transparent {\n    animation: glowAnimationSecondary 1s infinite alternate;\n}\n\n@keyframes glowAnimationTransparent{\n    0% {\n        box-shadow: 0 0 20px rgba(236, 106, 94, 0.8); /* Secondary glow color */\n    }\n    100% {\n        box-shadow: 0 0 40px rgba(236, 106, 94, 0.6); /* Secondary glow color */\n    }\n}","//Primary shades\n$primary_green: #00aa74;\n$primary_light: #e6f7ef;\n$primary_gradient: linear-gradient(109.42deg, #00aa74 0%, #16eba6 100%, #16eba6 100%);\n$primary_gradient1: linear-gradient(108deg, #00AA74 -78.7%, #1E1E1E 59.58%);\n\n//secondary shades\n$secondary_dark: #012515;\n\n//semantic\n$semantic_red: #ec6a5e;\n$semantic_orange: #dfa102;\n\n//Grey Shades\n$color_grey_400: #8c8c8c;\n$color_grey_300: #b3b3b3;\n$color_grey_200: #d9d9d9;\n$color_grey_100: #f2f2f2;\n\n//Black Shades\n$color_black_400: #000000;\n$color_black_300: #1e1e1e;\n$color_black_200: #333333;\n$color_black_100: #4c4c4c;\n\n//green shades\n$color_green_100: #e6f7ef;\n$color_green_150: #c2ead8;\n$color_green_200: #9adcbf;\n$color_green_300: #6ecfa6;\n$color_green_400: #48c493;\n$color_green_500: #09ba80;\n$color_green_600: #009766;\n$color_green_700: #00865a;\n$color_green_800: #006643;\n\n//Fontstyles\n$main_font: 'Syne', sans-serif;\n$secondary_font: 'Outfit', sans-serif;\n$tertiary_font: 'Space Grotesk', sans-serif;\n$text_size: 1rem;\n$dashboardtext: #575757;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
